import React from "react";
import { ReactComponent as ReviewStar } from "assets/svgs/star-rating.svg";
import { ReactComponent as WhiteReviewStar } from "assets/svgs/white-star-rating.svg";

const ReviewStars = ({ rating, className, color }) => (
    <div
        className={`flex gap-2 ${className} ${color ? "[&_svg]:fill-current [&_svg_path]:fill-current" : ""}`}
        style={color ? { color } : undefined}
    >
        {[...Array(5)].map((review, index) => {
            if (index < Math.round(rating)) return <ReviewStar key={Math.random()} />;
            return <WhiteReviewStar key={Math.random()} />;
        })}
    </div>
);

export default ReviewStars;
